"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const class_transformer_1 = require("class-transformer");
function TransformConstructor(ctors) {
  const toPlain = (0, class_transformer_1.Transform)(params => {
    if (params && params.value) {
      if (Array.isArray(params.value)) {
        return params.value.map(item => {
          if (typeof item === "string") {
            return ctors.find(ctor => ctor.name === item)?.name;
          } else if (item && item.name) {
            return ctors.find(ctor => ctor.name === item.name)?.name;
          }
          return null;
        }).filter(value => !!value);
      }
      if (typeof params.value === "string") {
        return ctors.find(ctor => ctor.name === params.value)?.name;
      } else if (params.value && params.value.name) {
        return ctors.find(ctor => ctor.name === params.value.name)?.name;
      }
    }
    return null;
  }, {
    toPlainOnly: true
  });
  const toClass = (0, class_transformer_1.Transform)(params => {
    if (params && params.value) {
      if (Array.isArray(params.value)) {
        return params.value.map(item => {
          if (typeof item === "string") {
            return ctors.find(ctor => ctor.name === item);
          } else if (item && item.name) {
            return ctors.find(ctor => ctor.name === item.name);
          }
          return null;
        }).filter(value => !!value);
      }
      if (typeof params.value === "string") {
        return ctors.find(ctor => ctor.name === params.value);
      } else if (params.value && params.value.name) {
        return ctors.find(ctor => ctor.name === params.value.name);
      }
    }
    return null;
  }, {
    toClassOnly: true
  });
  return function (target, key) {
    toPlain(target, key);
    toClass(target, key);
  };
}
exports.default = TransformConstructor;
